import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  INVOICES_REPORT_GET_JOB_LIST: createSagaAction('INVOICES_REPORT_GET_JOB_LIST'),
  INVOICES_REPORT_GET_ORGANIZATION_LIST: createSagaAction('INVOICES_REPORT_GET_ORGANIZATION_LIST'),
  INVOICES_REPORT_GET_FULL_REPORT: createSagaAction('INVOICES_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  invoicesReportGetJobList: ({ filters }) => ({
    type: constants.INVOICES_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  invoicesReportGetOrganizationList: ({ filters }) => ({
    type: constants.INVOICES_REPORT_GET_ORGANIZATION_LIST.ACTION,
    filters
  }),
  invoicesReportGetFullReport: ({ filters }) => ({
    type: constants.INVOICES_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.INVOICES_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.INVOICES_REPORT_GET_JOB_LIST.SUCCESS:
      return { ...state, error: null, loadingJobList: false, jobList: action.payload }

    case constants.INVOICES_REPORT_GET_ORGANIZATION_LIST.ACTION:
      return { ...state, error: null, loadingOrganizationList: true }
    case constants.INVOICES_REPORT_GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingOrganizationList: false,
        organizationList: action.payload
      }

    case constants.INVOICES_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.INVOICES_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/financial/invoicesReportActions.js